import { CarouselItem } from "pages/imageCreator/components/DragCard";

export const dropCases: CarouselItem[] = [
  {
    image: "/images/drop-case-1.png",
    title: "Transform your Image",
    description: "Transform images based on your text instructions",
  }
];
